module.exports = __webpack_public_path__ + "static/media/mongoose.c74e09b6.svg";